/**
 * Base64 Encode Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ITransformerTool } from '@/interfaces/ITool';

export const Base64EncodeTool: ITransformerTool = {
  id: 'base64-encode',
  name: 'Base64 Encode',
  description: 'Encode text to Base64',
  version: '1.0.0',
  type: 'transformer',
  category: 'Encoders & Decoders',
  keywords: ['base64', 'encode', 'encoding'],

  seo: {
    slug: 'base64-encode',
    pageTitle: 'Base64 Encoder - Free Online Tool',
    metaDescription: 'Encode text or data to Base64 format instantly. Supports UTF-8 input. Fast, private, runs entirely in your browser.',
    keywords: ['base64 encode', 'base64 encoder', 'text to base64', 'encode base64 online'],
    relatedTools: ['base64-decode', 'url-encode'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.TEXT, SEMANTIC_TYPES.JSON],
  outputType: SEMANTIC_TYPES.BASE64,

  attributes: [
    {
      name: 'urlSafe',
      type: 'boolean',
      label: 'URL Safe',
      defaultValue: false,
      description: 'Use URL-safe Base64 encoding (replaces +/ with -_)',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    // Convert string to Base64
    const encoded = btoa(unescape(encodeURIComponent(input)));
    
    // Convert to URL-safe if requested
    if (config.urlSafe) {
      return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }
    
    return encoded;
  },
};

